import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55746d16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "lg:flex lg:flex-row lg:justify-center lg:flex-wrap mt-x1" }

import siteContextStore from '@/shared/content/site-context.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchQuickLinks',
  props: {
    title: null
  },
  setup(__props: any) {



const quickLinks = siteContextStore.getQuickLinks();


return (_ctx: any,_cache: any) => {
  const _component_RouterLinkConditional = _resolveComponent("RouterLinkConditional")!

  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(__props.title), 1),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(quickLinks), (item, idx) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.linkModel.url+idx,
          class: "content-item"
        }, [
          _createVNode(_component_RouterLinkConditional, {
            to: item.linkModel.url,
            class: "c-magic-line text-14 inline",
            "spa-enabled": item.linkModel.spaLink
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to", "spa-enabled"])
        ]))
      }), 128))
    ])
  ]))
}
}

})